module.exports = __webpack_public_path__ + "img/ios.7a09f611.png";